import { Component, Input, OnInit } from '@angular/core';
import { IFatura } from './../../../../../interfaces/ifatura';
import { Convert } from './../../../../../utils/convert';
import { Fatura } from './../../../../../utils/fatura';

@Component({
  selector: 'eae-fatura-card',
  templateUrl: './eae-fatura-card.component.html',
  styles: [],
})
export class EaeFaturaCardComponent implements OnInit {
  @Input()
  fatura!: IFatura;

  constructor() {}

  ngOnInit(): void {}

  public isOverDue(dateFatura: string): boolean {
    return Fatura.isOverDue(dateFatura);
  }

  public formatCurrencyBrazil(value: string): string {
    return Convert.formatCurrencyBrazil(value);
  }

  public dateStringToBrazil(date: string): string {
    return Convert.dateStringToBrazil(date);
  }
}
